export type ReactionType = string; // 'like' | 'love' | 'clap' | 'smile' | 'laugh' | custom

export interface ReactionConfig {
  type: ReactionType;
  emoji: string;        // Unicode glyph — empty string when imageUrl is used
  imageUrl?: string;    // Custom emoji image URL; takes priority over emoji
  color: string;
  animationType?: 'bounce' | 'tada' | 'pulse';
}

export interface BuildingEmoji {
  uuid?: string;
  title: string;
  text?: string;
  url?: string;
  animationType?: string;
  meta?: {
    colorScheme?: string;
  };
}

export const DEFAULT_REACTIONS: ReactionConfig[] = [
  { type: 'like',  emoji: '👍', color: '#00B5D1', animationType: 'bounce' },
  { type: 'love',  emoji: '❤️', color: '#F32E30', animationType: 'tada'   },
  { type: 'clap',  emoji: '👏', color: '#6D89ED', animationType: 'pulse'  },
  { type: 'smile', emoji: '😊', color: '#FEC100', animationType: 'bounce' },
  { type: 'laugh', emoji: '😂', color: '#FEC100', animationType: 'tada'   },
];

